/**
 * A function to create a log object for the 'dummyName' event (evid: 100)
 *
 * @param {dummyNameParams} params - The parameters for this event
 * @return {LogObject<dummyNameParams>} LogObject<dummyNameParams>
 */
export function dummyName(params) {
    return { evid: 100, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'widgetModeShown' event (evid: 101)
 *
 * Event description: Widget mode shown
 *
 * @param {widgetModeShownParams} params - The parameters for this event
 * @property {string} parent_component_id - {id of parent component id}
 * @property {string} modes - {list of modes available}
 * @property {boolean} root_widget - {true/false}
 * @property {string} app_def_id - {id of widget}
 * @property {string} current_mode - {mode selected}
 * @property {string} parent_component_type - {type of parent component}
 * @property {string} origin - {Editor/Wix Studio/EditorX?}
 * @property {GUID} esi - {session id}
 * @property {string} component_id - {id of the component}
 * @property {string} component_type - {type of the component}
 * @property {string} host_app_id - {host application id}
 * @return {LogObject<widgetModeShownParams>} LogObject<widgetModeShownParams>
 */
export function widgetModeShown(params) {
    return { evid: 101, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'widgetModeChanged' event (evid: 102)
 *
 * Event description: Widget mode changed
 *
 * @param {widgetModeChangedParams} params - The parameters for this event
 * @property {string} parent_component_id - {id of parent component id}
 * @property {boolean} root_widget - {true/false}
 * @property {string} app_def_id - {id of widget}
 * @property {string} current_mode - {mode selected}
 * @property {string} parent_component_type - {type of parent component}
 * @property {string} origin - {Editor/Wix Studio/EditorX?}
 * @property {boolean} is_default_mode - {is default mode selected}
 * @property {GUID} esi - {session}
 * @property {string} component_id - {id of the component}
 * @property {string} component_type - {type of the component}
 * @property {string} host_app_id - {host application id}
 * @return {LogObject<widgetModeChangedParams>} LogObject<widgetModeChangedParams>
 */
export function widgetModeChanged(params) {
    return { evid: 102, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'pluginAdded' event (evid: 103)
 *
 * Event description: Plugin added
 *
 * @param {pluginAddedParams} params - The parameters for this event
 * @property {string} role - {user or dev for installations by default in host app id}
 * @property {string} uuid - {uuid}
 * @property {string} slot_id - {slot_id where plugin installed}
 * @property {string} site_builder_type - {site_builder type: Editor, edix and etc}
 * @property {string} app_def_id_plugin - app_def_id_plugin
 * @property {string} origin - origin of install
 * @property {string} editorType - {editor type value}
 * @property {string} target_type - {addons/widget etc}
 * @property {string} plugin_id - {id of plugin installed}
 * @property {GUID} esi - {session guid}
 * @property {GUID} msid - {guid of site}
 * @property {string} placement_id - {placement id consist of plugin id, slot id}
 * @property {string} host_app_id - {id of add-ons/plugin installed}
 * @property {GUID} installationId - {unique installation id}
 * @property {string} appType - {app type like intent, not intent}
 * @return {LogObject<pluginAddedParams>} LogObject<pluginAddedParams>
 */
export function pluginAdded(params) {
    return { evid: 103, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'addOnsSelected' event (evid: 104)
 *
 * Event description: Add-ons selected
 *
 * @param {addOnsSelectedParams} params - The parameters for this event
 * @property {string} target_action - {target action selected: get, manage and etc}
 * @property {string} uuid - {uuid}
 * @property {string} site_builder_type - {site_builder type: Editor, edix and etc}
 * @property {string} origin - {panel_name or tools/RCM}
 * @property {string} editorType - {editor type value}
 * @property {string} target_type - {addons/widget etc}
 * @property {GUID} esi - {session guid}
 * @property {GUID} msid - {site guid}
 * @return {LogObject<addOnsSelectedParams>} LogObject<addOnsSelectedParams>
 */
export function addOnsSelected(params) {
    return { evid: 104, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'addPluginTry' event (evid: 105)
 *
 * Event description: Add plugin try
 *
 * @param {addPluginTryParams} params - The parameters for this event
 * @property {string} role - {user or dev for installations by default in host app id}
 * @property {string} uuid - {uuid}
 * @property {string} slot_id - {slot id where plugin would be added}
 * @property {string} site_builder_type - {site_builder type: Editor, edix and etc}
 * @property {string} origin - {origin of adding add-ons/plugins}
 * @property {string} editorType - {editor type value}
 * @property {string} target_type - {addons/widget etc}
 * @property {string} plugin_id - {id of plugin}
 * @property {GUID} esi - {session guid}
 * @property {GUID} msid - {site guid}
 * @property {string} host_app_id - {id of add-on/plugin}
 * @property {GUID} installationId - {unique installation id}
 * @property {string} appType - {app type like intent, not intent}
 * @return {LogObject<addPluginTryParams>} LogObject<addPluginTryParams>
 */
export function addPluginTry(params) {
    return { evid: 105, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'pluginRemoveClick' event (evid: 106)
 *
 * Event description: Plugin remove click
 *
 * @param {pluginRemoveClickParams} params - The parameters for this event
 * @property {string} method - {method of removing: click, keyboard etc}
 * @property {string} uuid - {uuid}
 * @property {string} slot_id - {slot_id from which plugin was removed}
 * @property {string} site_builder_type - {site_builder type: Editor, edix and etc}
 * @property {string} origin - {origin of removing/ name of the panel}
 * @property {string} editorType - { editor type}
 * @property {string} target_type - {addons/widget etc}
 * @property {string} plugin_id - {id of plugin}
 * @property {GUID} esi - {session guid}
 * @property {GUID} msid - {site guid}
 * @return {LogObject<pluginRemoveClickParams>} LogObject<pluginRemoveClickParams>
 */
export function pluginRemoveClick(params) {
    return { evid: 106, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'pluginRemoved' event (evid: 107)
 *
 * Event description: Plugin removed
 *
 * @param {pluginRemovedParams} params - The parameters for this event
 * @property {string} method - {method of removing: click, keyboard etc}
 * @property {string} role - {user or dev for installations by default in host app id}
 * @property {string} uuid - {uuid}
 * @property {string} slot_id - {slot_id from which plugin was removed}
 * @property {string} site_builder_type - {site_builder type: Editor, edix and etc}
 * @property {string} origin - {name of panel/ origin of removing}
 * @property {string} editorType - {editor type}
 * @property {string} target_type - {addons/widget etc}
 * @property {string} plugin_id - {id of plugin}
 * @property {GUID} esi - esi
 * @property {GUID} msid - {site guid}
 * @property {string} placement_id - {placement id consist of plugin id, slot id}
 * @property {string} host_app_id - {id of add-on/plugin/host}
 * @property {GUID} installationId - {unique installation ID}
 * @property {string} appType - {app type like intent, not intent}
 * @return {LogObject<pluginRemovedParams>} LogObject<pluginRemovedParams>
 */
export function pluginRemoved(params) {
    return { evid: 107, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'pluginInteraction' event (evid: 108)
 *
 * Event description: Add-on/Plugin interaction - any action inside app
 *
 * @param {pluginInteractionParams} params - The parameters for this event
 * @property {string} uuid - {uuid}
 * @property {string} site_builder_type - {site builder type: Editor, Edix and etc}
 * @property {string} appDefinitionId - {app definition id}
 * @property {string} editorType - {editor type}
 * @property {GUID} esi - {session guid}
 * @property {GUID} msid - {site guid}
 * @property {string} action - {action inside of the add-on/plugin: toggle on/off, set grid, add spacing and etc}
 * @return {LogObject<pluginInteractionParams>} LogObject<pluginInteractionParams>
 */
export function pluginInteraction(params) {
    return { evid: 108, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'presetSelected' event (evid: 109)
 *
 * Event description: Preset selected
 *
 * @param {presetSelectedParams} params - The parameters for this event
 * @property {string} previous_value - {previously selected preset/category}
 * @property {string} uuid - {user uuid}
 * @property {string} site_builder_type - {site builder type: Classic Editor, EdiX, Wix Studio etc}
 * @property {string} origin - {origin of change}
 * @property {string} editorType - {editor type}
 * @property {string} target_type - {preset or category}
 * @property {string} app_id - {id of the app: gallery and etc}
 * @property {string} target - {selected preset/category}
 * @property {GUID} esi - {session guid}
 * @property {string} component_id - {id of the component selected}
 * @property {GUID} msid - {site guid}
 * @property {string} host_app_id - {id of the host app id: Wix Stores, Wix Bookings etc}
 * @return {LogObject<presetSelectedParams>} LogObject<presetSelectedParams>
 */
export function presetSelected(params) {
    return { evid: 109, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'pagesReplaceWithCustomPageChoice' event (evid: 110)
 *
 * Event description: Click inside replace with custom page panel
 *
 * @param {pagesReplaceWithCustomPageChoiceParams} params - The parameters for this event
 * @property {string} uuid - user guid
 * @property {string} editorType - {site builder type}
 * @property {string} target - {cancel, create}
 * @property {GUID} esi - session guid
 * @property {GUID} msid - site guid
 * @return {LogObject<pagesReplaceWithCustomPageChoiceParams>} LogObject<pagesReplaceWithCustomPageChoiceParams>
 */
export function pagesReplaceWithCustomPageChoice(params) {
    return { evid: 110, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'replacementPageSucceeded' event (evid: 111)
 *
 * Event description: Replacement page succeeded - send after page was successfully replaced by custom/default page
 *
 * @param {replacementPageSucceededParams} params - The parameters for this event
 * @property {string} replacement_page - {replaced page id}
 * @property {string} uuid - user guid
 * @property {string} editorType - {site builder type}
 * @property {string} app_id - {app id added if applicable}
 * @property {string} original_page - {original page id}
 * @property {GUID} esi - session guid
 * @property {GUID} msid - site guid
 * @property {string} host_app_id - {id of host app id}
 * @return {LogObject<replacementPageSucceededParams>} LogObject<replacementPageSucceededParams>
 */
export function replacementPageSucceeded(params) {
    return { evid: 111, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'conflictingPagesActions' event (evid: 112)
 *
 * Event description: Conflicting pages actions
 *
 * @param {conflictingPagesActionsParams} params - The parameters for this event
 * @property {string} uuid - user guid
 * @property {string} default_page_id - {id of page that is being replaced}
 * @property {string} page_id - {id of page that is replacing}
 * @property {string} page_name - {name of page}
 * @property {string} editorType - {site builder type}
 * @property {string} app_id - {id of app}
 * @property {string} target - {cancel, replace}
 * @property {GUID} esi - session guid
 * @property {GUID} msid - site guid
 * @return {LogObject<conflictingPagesActionsParams>} LogObject<conflictingPagesActionsParams>
 */
export function conflictingPagesActions(params) {
    return { evid: 112, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'tpaMessageLoaded' event (evid: 113)
 *
 * Event description: TPA message loaded
 *
 * @param {tpaMessageLoadedParams} params - The parameters for this event
 * @property {string} description - {Deleting page with App on it, Trying to delete TPA page...}
 * @property {string} uuid - {user guid}
 * @property {string} editorType - {site builder}
 * @property {string} app_id - {app id}
 * @property {string} type - {delete_premium, add_page,...}
 * @property {GUID} esi - {session guid}
 * @property {GUID} msid - {site guid}
 * @return {LogObject<tpaMessageLoadedParams>} LogObject<tpaMessageLoadedParams>
 */
export function tpaMessageLoaded(params) {
    return { evid: 113, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'platformInstallation' event (evid: 114)
 *
 * Event description: New platform API that is replacing DM installation
 *
 * @param {platformInstallationParams} params - The parameters for this event
 * @property {number} duration - {duration time to success for end step}
 * @property {GUID} installationId - {unique installation id}
 * @property {string} appDefinitionId - {app_defintion_id if applicable}
 * @property {string} origin - {origin of install}
 * @property {string} editorType - {Classic Editor, editorx, studio}
 * @property {string} type - {start/end phase}
 * @property {string} appType - {app type like intent, not intent}
 * @return {LogObject<platformInstallationParams>} LogObject<platformInstallationParams>
 */
export function platformInstallation(params) {
    return { evid: 114, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'provisionApps' event (evid: 115)
 *
 * Event description: Provision Apps - DM export method
 *
 * @param {provisionAppsParams} params - The parameters for this event
 * @property {number} duration - {time to success for end step}
 * @property {string} name - {name step or DM method name to export}
 * @property {GUID} installationId - {unique installation id}
 * @property {string} appDefinitionId - {app definition id}
 * @property {string} origin - {origin of install}
 * @property {string} editorType - {Classic Editor, editorX, Studio}
 * @property {string} type - {start/end step of the phase}
 * @property {string} appType - {app type like intent or not intent}
 * @return {LogObject<provisionAppsParams>} LogObject<provisionAppsParams>
 */
export function provisionApps(params) {
    return { evid: 115, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'newComponentsInstall' event (evid: 116)
 *
 * Event description: Install all new pages components.
 *
 * @param {newComponentsInstallParams} params - The parameters for this event
 * @property {number} duration - {time to success for end}
 * @property {string} name - {name of method/phase}
 * @property {number} numberTotalComponents - {number of total components to install}
 * @property {string} typeInstallation - {Page, Widget, Script & Plugin}
 * @property {GUID} installationId - {unique installation id}
 * @property {string} componentsList - {list of components to install}
 * @property {string} appDefinitionId - {app definition id}
 * @property {number} numberInstalledComponents - {number of installed components for pages}
 * @property {string} origin - {origin of install}
 * @property {string} editorType - {Classic Editor, editorX, Studio}
 * @property {string} type - {start/end of the phase}
 * @property {string} appType - {app type like intent or not intent}
 * @return {LogObject<newComponentsInstallParams>} LogObject<newComponentsInstallParams>
 */
export function newComponentsInstall(params) {
    return { evid: 116, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'blocksPackagesInstall' event (evid: 118)
 *
 * Event description: Installation of Blocks packages
 *
 * @param {blocksPackagesInstallParams} params - The parameters for this event
 * @property {number} duration - {time to success for end step}
 * @property {string} name - {name of the step/component to install}
 * @property {GUID} installationId - {unique installation id}
 * @property {string} appDefinitionId - {app_defintion_id if applicable}
 * @property {string} origin - {origin of install}
 * @property {string} editorType - {Classic Editor, editorX, Studio}
 * @property {string} type - {start/end of the phase}
 * @property {string} appType - {app intent like intent or not intent}
 * @return {LogObject<blocksPackagesInstallParams>} LogObject<blocksPackagesInstallParams>
 */
export function blocksPackagesInstall(params) {
    return { evid: 118, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'platformRunScripts' event (evid: 119)
 *
 * Event description: Platform run scripts
 *
 * @param {platformRunScriptsParams} params - The parameters for this event
 * @property {number} duration - {time to success for end step}
 * @property {string} name - {name of the step/component to install}
 * @property {GUID} installationId - {unique installation id}
 * @property {string} appDefinitionId - {app_defintion_id if applicable}
 * @property {string} origin - {origin of install}
 * @property {string} editorType - {Classic Editor, editorX, Studio}
 * @property {string} type - {start/end of the phase}
 * @property {string} appType - {app type like intent or not intent}
 * @return {LogObject<platformRunScriptsParams>} LogObject<platformRunScriptsParams>
 */
export function platformRunScripts(params) {
    return { evid: 119, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'navigateToDevCenter' event (evid: 120)
 *
 * Event description: Navigate to default widget set in app settings in devCenter
 *
 * @param {navigateToDevCenterParams} params - The parameters for this event
 * @property {GUID} installationId - {unique installation id}
 * @property {string} appDefinitionId - {app_defintion_id if applicable}
 * @property {string} origin - {origin of install}
 * @property {string} editorType - {Classic Editor, editorX, Studio}
 * @property {string} appType - {app type like intent or not intent}
 * @return {LogObject<navigateToDevCenterParams>} LogObject<navigateToDevCenterParams>
 */
export function navigateToDevCenter(params) {
    return { evid: 120, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'platformError' event (evid: 121)
 *
 * Event description: Errors
 *
 * @param {platformErrorParams} params - The parameters for this event
 * @property {string} name - {step in the flow where error occurred}
 * @property {string} errorData - {error data}
 * @property {string} errorMessage - {error message}
 * @property {GUID} installationId - {unique installation id}
 * @property {string} appDefinitionId - {app id where error occurred}
 * @property {string} pageId - {page with error}
 * @property {string} errorDetails - {any other error details}
 * @property {string} errorType - {type of the error}
 * @property {string} errorCode - {error code}
 * @property {string} editorType - {Classic Editor, editorX, studio}
 * @property {string} pageType - {page with error}
 * @property {string} sdkVersion - editorSdkVersion
 * @property {string} type - {type of the component, page, widget, plugin, script}
 * @property {GUID} esi - {unique session id}
 * @property {string} appType - {app type like intent or not intent}
 * @return {LogObject<platformErrorParams>} LogObject<platformErrorParams>
 */
export function platformError(params) {
    return { evid: 121, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'platformInit' event (evid: 122)
 *
 * Event description: generic entry event
 *
 * @param {platformInitParams} params - The parameters for this event
 * @property {string} step - {start, end}
 * @property {string} uuid - {unique user id}
 * @property {GUID} esi - {unique session id}
 * @return {LogObject<platformInitParams>} LogObject<platformInitParams>
 */
export function platformInit(params) {
    return { evid: 122, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'platformWorkerSpawn' event (evid: 123)
 *
 * Event description: we create a worker, but we might have different strategies (single, one-per-app, etc)
 *
 * @param {platformWorkerSpawnParams} params - The parameters for this event
 * @property {string} step - {start, end}
 * @property {string} uuid - {unique user id}
 * @property {string} strategy - {single, one-per-app, etc}
 * @property {string} workerId - {unique worker id}
 * @property {GUID} esi - {unique session id}
 * @return {LogObject<platformWorkerSpawnParams>} LogObject<platformWorkerSpawnParams>
 */
export function platformWorkerSpawn(params) {
    return { evid: 123, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'platformAppRunnerInitAppApi' event (evid: 124)
 *
 * Event description: pre-create app APIs
 *
 * @param {platformAppRunnerInitAppApiParams} params - The parameters for this event
 * @property {string} appType - {app type}
 * @property {string} step - {start, end}
 * @property {string} uuid - {unique user id}
 * @property {GUID} appDefId - {app definition id guid}
 * @property {GUID} esi - {unique session id}
 * @return {LogObject<platformAppRunnerInitAppApiParams>} LogObject<platformAppRunnerInitAppApiParams>
 */
export function platformAppRunnerInitAppApi(params) {
    return { evid: 124, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'platformAppRunnerRunApp' event (evid: 125)
 *
 * Event description: generic process of loading, evaluating and running the app bundle
 *
 * @param {platformAppRunnerRunAppParams} params - The parameters for this event
 * @property {string} appType - {app type}
 * @property {string} step - {start, end}
 * @property {string} uuid - {unique user id}
 * @property {GUID} appDefId - {app unique id}
 * @property {GUID} esi - {unique session id}
 * @return {LogObject<platformAppRunnerRunAppParams>} LogObject<platformAppRunnerRunAppParams>
 */
export function platformAppRunnerRunApp(params) {
    return { evid: 125, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'platformAppRunnerRemoveApp' event (evid: 126)
 *
 * Event description: generic process of app removal
 *
 * @param {platformAppRunnerRemoveAppParams} params - The parameters for this event
 * @property {string} appType - {app type}
 * @property {string} step - {start, end}
 * @property {string} uuid - {unique user id}
 * @property {GUID} appDefId - {app definition id}
 * @property {GUID} esi - {unique session id}
 * @return {LogObject<platformAppRunnerRemoveAppParams>} LogObject<platformAppRunnerRemoveAppParams>
 */
export function platformAppRunnerRemoveApp(params) {
    return { evid: 126, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'platformWorkerAppBundleLoad' event (evid: 127)
 *
 * Event description: loading of JS bundle
 *
 * @param {platformWorkerAppBundleLoadParams} params - The parameters for this event
 * @property {string} appType - {app type}
 * @property {string} step - {start, end}
 * @property {string} uuid - {unique user id}
 * @property {GUID} appDefId - {app definition id}
 * @property {GUID} esi - {unique session id}
 * @property {string} bundleUrl - {url of bundle, js of the file}
 * @return {LogObject<platformWorkerAppBundleLoadParams>} LogObject<platformWorkerAppBundleLoadParams>
 */
export function platformWorkerAppBundleLoad(params) {
    return { evid: 127, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'platformWorkerAppBundleExecute' event (evid: 128)
 *
 * Event description: execution of the loaded bundle
 *
 * @param {platformWorkerAppBundleExecuteParams} params - The parameters for this event
 * @property {string} appType - {app type}
 * @property {string} step - {start, end}
 * @property {string} uuid - {unique user id}
 * @property {GUID} appDefId - {app definition id}
 * @property {GUID} esi - {unique session id}
 * @property {string} bundleUrl - {url of bundle, file js}
 * @return {LogObject<platformWorkerAppBundleExecuteParams>} LogObject<platformWorkerAppBundleExecuteParams>
 */
export function platformWorkerAppBundleExecute(params) {
    return { evid: 128, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'platformIframeInit' event (evid: 129)
 *
 * Event description: setup communication link between our infra and an iframe
 *
 * @param {platformIframeInitParams} params - The parameters for this event
 * @property {string} step - {start, end}
 * @property {string} uuid - {unique user id}
 * @property {string} frameUrl - {js file for frame}
 * @property {string} iframeId - {iframe id}
 * @property {GUID} esi - {unique session id}
 * @return {LogObject<platformIframeInitParams>} LogObject<platformIframeInitParams>
 */
export function platformIframeInit(params) {
    return { evid: 129, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'platformAppApiInit' event (evid: 130)
 *
 * Event description: app exposes an api (public or private)
 *
 * @param {platformAppApiInitParams} params - The parameters for this event
 * @property {string} appType - {app type}
 * @property {string} step - {start, end}
 * @property {string} scope - {private, public}
 * @property {string} uuid - {unique user id}
 * @property {GUID} appDefId - {app definition id}
 * @property {GUID} esi - {unique session id}
 * @return {LogObject<platformAppApiInitParams>} LogObject<platformAppApiInitParams>
 */
export function platformAppApiInit(params) {
    return { evid: 130, src: 164, endpoint: 'editor-platform', params: params };
}
/**
 * A function to create a log object for the 'platformAppApiGet' event (evid: 131)
 *
 * Event description: app requests another public app api, or app requests its own private api
 *
 * @param {platformAppApiGetParams} params - The parameters for this event
 * @property {string} appType - {app type}
 * @property {string} step - {start, end}
 * @property {string} scope - {private, public}
 * @property {string} uuid - {unique user id}
 * @property {GUID} appDefId - {app definition id}
 * @property {string} targetAppDefId - {targeted app id}
 * @property {GUID} esi - {unique session id}
 * @return {LogObject<platformAppApiGetParams>} LogObject<platformAppApiGetParams>
 */
export function platformAppApiGet(params) {
    return { evid: 131, src: 164, endpoint: 'editor-platform', params: params };
}
//# sourceMappingURL=index.js.map